module.exports = __webpack_public_path__ + "img/th.f8c124a8.svg";